<template>
  <div class="spinner-contaner">
    <div>
      <fade-loader :loading="loading" :color="'grey'" :size="'120px'"></fade-loader>
      <p class="icon-text">Please wait</p>
    </div>
  </div>
</template>
<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import GridLoader from "vue-spinner/src/GridLoader.vue";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import RiseLoader from "vue-spinner/src/RiseLoader.vue";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import SyncLoader from "vue-spinner/src/SyncLoader.vue";
import RotateLoader from "vue-spinner/src/RotateLoader.vue";
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
import PacmanLoader from "vue-spinner/src/PacmanLoader.vue";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import SkewLoader from "vue-spinner/src/SkewLoader.vue";
import MoonLoader from "vue-spinner/src/MoonLoader.vue";
import RingLoader from "vue-spinner/src/RingLoader.vue";
import BounceLoader from "vue-spinner/src/BounceLoader.vue";
import DotLoader from "vue-spinner/src/DotLoader.vue";

export default {
  name: "ButtonLoader",
  components: {
    PulseLoader,
    GridLoader,
    ClipLoader,
    RiseLoader,
    BeatLoader,
    SyncLoader,
    RotateLoader,
    FadeLoader,
    PacmanLoader,
    SquareLoader,
    ScaleLoader,
    SkewLoader,
    MoonLoader,
    RingLoader,
    BounceLoader,
    DotLoader
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss">
.spinner-contaner {
  display: flex;
  height: 600px;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  opacity: 0.4;
  .icon-text {
    margin-top: 60px;
    margin-left: -30px;
  }
}
</style>